export default __webpack_public_path__ + "static/media/wavesofflame.3df172d6.png";